import { GetAllHealthPlans } from 'domain/usecases/patient/get-all-health-plans'
import { PatientNewRepository } from 'repository/interfaces/patient-new-repository'

export class RemoteGetAllHealthPlans implements GetAllHealthPlans {
  private readonly patientNewRepository: PatientNewRepository

  constructor(patientNewRepository: PatientNewRepository) {
    this.patientNewRepository = patientNewRepository
  }

  get(): Promise<GetAllHealthPlans.Model> {
    return this.patientNewRepository.getAllHealthPlans()
  }
}
